import httpService from './httpService'

const serverPath = window.location.origin
const arsmoApi = '/arsmo_api'

const customerService = {
  getCustomerInfo: (params) => {
    const url = `${serverPath}${arsmoApi}/customer`
    return httpService.httpGet(url, params)
  },
  wxPreBind: (param) => { //预绑定
    const url = `${serverPath}${arsmoApi}/customer/prebind`
    return httpService.httpPost(url, param)
  },
  getCustomerInfoByMobile: (params) => {
    const url = `${serverPath}${arsmoApi}/customer/mobile`
    return httpService.httpGet(url, params)
  },
  wxBind: (param) => { //绑定
    const url = `${serverPath}${arsmoApi}/customer/bind`
    return httpService.httpPost(url, param)
  },
  registCustomer:(param) => {
    const url = `${serverPath}${arsmoApi}/customer`
    return httpService.httpPost(url, param)
  },
  getCustomerPoints:(param) => {
    const url = `${serverPath}${arsmoApi}/customer/points`
    return httpService.httpGet(url, param)
  }
}

export default customerService



// WEBPACK FOOTER //
// ./src/services/customer-service.js